"use client";

import { Card } from "@/components/ui/card";
import { motion } from "framer-motion";

interface StoryItem {
  quote: string;
  name: string;
  location: string;
  rating?: number;
}

const stories: StoryItem[] = [
  {
    quote:
      "We went from one premium wall finish every other week to multiple microcement bath inquiries after getting featured. The visibility upgrade paid for itself instantly.",
    name: "Artisan Surface Studio",
    location: "Phoenix, AZ",
    rating: 5,
  },
  {
    quote:
      "Designers finally FIND us when searching for Venetian plaster. Our phone rings with clients referencing our textures directly from the listing—best marketing spend we’ve made.",
    name: "Elevate Plaster Co.",
    location: "Tampa, FL",
    rating: 5,
  },
  {
    quote:
      "Projects now come in from two cities over because homeowners discovered us in the directory. We’re booking higher-value microcement showers and feature walls consistently.",
    name: "SurfaceCraft Finishes",
    location: "Dallas, TX",
    rating: 5,
  },
];

export function SuccessStoriesSection() {
  return (
    <section className="py-24 md:py-32 bg-muted/30 dark:bg-background">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16 max-w-3xl mx-auto"
        >
          <h2 className="text-3xl md:text-5xl font-bold mb-4">
            Success Stories From{" "}
            <span className="text-primary">Applicators</span>
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground">
            Real results from plaster & microcement specialists growing
            visibility and winning premium finish projects.
          </p>
        </motion.div>

        <div className="grid gap-8 md:grid-cols-3 max-w-6xl mx-auto">
          {stories.map((story, idx) => (
            <motion.div
              key={story.name}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: idx * 0.08 }}
            >
              <Card className="p-6 h-full flex flex-col bg-card dark:bg-muted border border-border/60">
                <div
                  className="flex mb-3"
                  aria-label={`${story.rating} star rating`}
                >
                  {Array.from({ length: story.rating || 5 }).map((_, i) => (
                    <span key={i} className="text-yellow-500 text-lg">
                      ★
                    </span>
                  ))}
                </div>
                <p className="text-sm text-muted-foreground leading-relaxed mb-5 flex-1">
                  “{story.quote}”
                </p>
                <div className="mt-auto">
                  <div className="font-semibold text-foreground">
                    {story.name}
                  </div>
                  <div className="text-xs text-muted-foreground">
                    {story.location}
                  </div>
                </div>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
